import { render, staticRenderFns } from "./d-activity-book.vue?vue&type=template&id=065f10e3&scoped=true&"
import script from "./d-activity-book.vue?vue&type=script&lang=js&"
export * from "./d-activity-book.vue?vue&type=script&lang=js&"
import style0 from "./d-activity-book.vue?vue&type=style&index=0&id=065f10e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f10e3",
  null
  
)

export default component.exports